import { render, staticRenderFns } from "./CreateCustomerInquiryPopUp.vue?vue&type=template&id=65774d0e&scoped=true&"
import script from "./CreateCustomerInquiryPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerInquiryPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerInquiryPopUp.vue?vue&type=style&index=0&id=65774d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65774d0e",
  null
  
)

export default component.exports